import { CopyCheckIcon, CopyIcon } from 'lucide-react'
import React, { useState } from 'react'

interface ClipboardProps {
  value: string
  children: React.ReactNode
}

export const Clipboard = ({ value, children }: ClipboardProps) => {
  const [isCopied, setIsCopied] = useState(false)

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(value)
      setIsCopied(true)
      setTimeout(() => {
        setIsCopied(false)
      }, 2000)
    } catch (err) {
      console.error('Failed to copy text: ', err)
    }
  }

  return (
    <span
      onClick={handleCopy}
      className="cursor-pointer inline-flex items-center gap-1 hover:opacity-80 transition-opacity"
    >
      {children}
      {isCopied ? (
        <CopyCheckIcon className="h-4 w-4" />
      ) : (
        <CopyIcon className="h-4 w-4" />
      )}
    </span>
  )
}
